import React, { Component } from 'react';
import Modal from 'react-modal';
import { Spinner } from 'react-activity';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class AddRemoveStudent extends Component {
    render() {
        const { externalEmails = [], currentEmail = '' } = this.props;

        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={this.props.closeModal}
                className={'modal-add-student-width'}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-card">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-semibold text-white">
                                {this.props.t('externalMembers')}
                            </h3>
                            <button type="button" onClick={() => this.props.closeModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="grid grid-cols-1 mt-2">
                            <div className="flex items-center mb-2">
                                <input
                                    type="text"
                                    value={currentEmail}
                                    onChange={this.props.onInputChange}
                                    placeholder={this.props.t('enterAnEmailAddress')}
                                    className="w-full border border-black-10 bg-dateselect text-base text-white rounded py-1.5 px-2"
                                    maxLength={100}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            this.props.onAddEmail();
                                        }
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={this.props.onAddEmail}
                                    className="flex items-center justify-center w-6 h-6 ml-2 rounded-full bg-UIprimary sm:w-8 sm:h-8"
                                >
                                    <i
                                        className="text-white fas fa-plus"
                                        style={{ fontSize: '11px' }}
                                    ></i>
                                </button>
                            </div>

                            <div className="flex flex-wrap gap-2">
                                {externalEmails.map((email, index) => (
                                    <div
                                        key={`${email}-${index}`}
                                        className="inline-flex items-center rounded text-white overflow-hidden"
                                        style={{ backgroundColor: '#543cc2', borderRadius: '4px' }}
                                    >
                                        <span className="px-2 py-1 text-sm leading-none">{email}</span>
                                        <button
                                            type="button"
                                            onClick={() => this.props.onRemoveEmail(index)}
                                            className="px-2 py-1 text-sm leading-none text-white"
                                            style={{ backgroundColor: '#543cc2' }}
                                        >
                                            &times;
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                data-modal-hide="defaultModal"
                                className="w-3/12 py-2 text-base font-semibold text-white bg-black rounded-lg"
                                onClick={() => this.props.closeModal()}
                            >
                                {this.props.t('cancel')}
                            </button>
                            &nbsp;&nbsp;
                            <button
                                data-modal-hide="defaultModal"
                                className="w-3/12 py-2 text-base font-semibold text-white rounded-lg bg-UIprimary"
                                onClick={() => {
                                    const email = (currentEmail || '').trim();
                                    if (email) {
                                        this.props.showValidationError(
                                            this.props.t('addEmailBeforeSaveError')
                                        );
                                        return;
                                    }
                                    this.props.saveExternalEmails();
                                }}
                                disabled={this.props.isSaveExternalEmail}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.props.isSaveExternalEmail ? (
                                        <Spinner color="#FFF" />
                                    ) : (
                                        this.props.t('save')
                                    )}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const ConnectedAddRemoveStudent = withLanguage(AddRemoveStudent);

export default (props) => (
    <LanguageProvider>
        <ConnectedAddRemoveStudent {...props} />
    </LanguageProvider>
);
